import React from "react";

import { Close as CloseIcon } from "@mui/icons-material";
import MIconButton, { IconButtonProps } from "@mui/material/IconButton";
import MList from "@mui/material/List";
import MListItem from "@mui/material/ListItem";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const Container = styled("div", { name: "AppViewerDrawerContainer" })<{
  fullHeight?: boolean;
}>(({ fullHeight }) => ({
  display: "flex",
  height: fullHeight ? "100%" : undefined,
  overflow: "auto",
}));

export const SideMenu = styled("div")(() => ({
  width: "15vw",
  maxWidth: 220,
  background: "#F8F9FC",
  borderRadius: 8,
  padding: "24px 16px",
  marginRight: 5,
}));

export const List = styled(MList)(() => ({ padding: "0px !important" }));

export const ListTitle = styled(MListItem)(() => ({
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "14px",
  letterSpacing: "1.2px",
  color: colors.gray500,
  marginBottom: "16px",
  paddingLeft: "24px !important",
}));

export const ListItem = styled(MListItem, {
  shouldForwardProp(propName) {
    return propName !== "isActive";
  },
})<{ isActive?: boolean }>(({ isActive }) => ({
  font: "700 16px/24px Manrope",
  color: isActive ? colors.gray600 : colors.gray400,
  cursor: "pointer",
  padding: "10px 24px !important",
}));

export const Main = styled("div")(() => ({
  width: "70vw",
  background: "white",
  borderRadius: 8,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  "@media (max-width: 1024px)": {
    width: "65vw",
  },
  "@media (max-width: 768px)": {
    width: "60vw",
  },
}));

export const MainTitle = styled("div")(() => ({
  display: "flex",
  padding: "12px 24px",
  backgroundColor: colors.blue50,
}));

export const MainTitleLabel = styled("div")(() => ({
  flex: 1,
  color: colors.brandBlue500,

  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const MainTitleCloseButton = styled((props: IconButtonProps) => (
  <MIconButton size="small" {...props}>
    <CloseIcon />
  </MIconButton>
))(() => ({
  borderRadius: "8px !important",
  marginLeft: "auto",
}));

export const MainContent = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
  flex: 1,
}));

export const Section = styled("section")(() => ({}));

export const SectionTitle = styled("div")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "22px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "28px",
  padding: "12px 24px",
  backgroundColor: colors.gray50,
  display: "flex",
  alignItems: "center",
}));

export const SectionContent = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "disableGutters" && propName !== "disableMinHeight";
  },
})<{ disableGutters?: boolean; disableMinHeight?: boolean }>(
  ({ disableGutters, disableMinHeight }) => ({
    padding: disableGutters ? undefined : "24px",
    minHeight: disableMinHeight ? undefined : "400px",
  })
);
